import { GridColDef } from "@mui/x-data-grid";

const pincodeColumnDefs: GridColDef[] = [
    { field: 'pin_code', headerName: 'Pin Code', width: 150 },
    { field: 'area_name', headerName: 'Area', width: 150 },
    { field: 'district', headerName: 'District', width: 150 },
    { field: 'state_name', headerName: 'State', width: 150 },
    { field: 'latitude', headerName: 'Latitude', width: 150 },
    { field: 'longitude', headerName: 'Longitude', width: 150 },
    { field: 'created_date', headerName: 'Created Date', width: 150 },
    { field: 'created_by', headerName: 'Created By', width: 150 },
];

export default pincodeColumnDefs;